const logSettingsActionTypes = {
    RETRIEVED_LOGTYPE_OPTIONS: "RETRIEVED_LOGTYPE_OPTIONS",
    RETRIEVED_PORTAL_OPTIONS: "RETRIEVED_PORTAL_OPTIONS",
    RETRIEVED_KEEPMOSTRECENT_OPTIONS: "RETRIEVED_KEEPMOSTRECENT_OPTIONS",
    RETRIEVED_OCCURRENCE_OPTIONS: "RETRIEVED_OCCURRENCE_OPTIONS",
    RETRIEVED_LOGSETTING_LIST: "RETRIEVED_LOGSETTING_LIST",
    RETRIEVED_LOGSETTING_BY_ID: "RETRIEVED_LOGSETTING_BY_ID",
    RETRIEVED_LATEST_LOGSETTING: "RETRIEVED_LATEST_LOGSETTING",
    UPDATED_LOGSETTING: "UPDATED_LOGSETTING",
    ADDED_LOGSETTING: "ADDED_LOGSETTING",
    DELETED_LOGSETTING: "DELETED_LOGSETTING"
};
export default logSettingsActionTypes;
